import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SnackBarAlertContext } from "../../../contexts/SnackbarContext";
import { SidebarContext } from "../../../contexts/SidebarContext";
import request from "../../../request";

interface UseQueryResponse<T> {
  loading: boolean;
  error: any;
  data: T | null;
}

const useQuery = <T,>(
  endPoint: string,
  variables?: any,
  reDirectTo?: string | null,
  apiCall = true
): UseQueryResponse<T> & { fetchData: () => Promise<void> } => {
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const { payload } = useContext(SidebarContext);

  const navigate = useNavigate();
  const [response, setResponse] = useState<UseQueryResponse<T>>({
    loading: true,
    error: null,
    data: null,
  });

  const fetchData = async () => {
    try {
      setResponse({
        loading: true,
        data: null,
        error: null,
      });
      const apiResponse = await request.get(endPoint, variables);
      setResponse({
        loading: false,
        data: apiResponse.data,
        error: null,
      });
    } catch (error: any) {
      setResponse({ loading: false, data: null, error });
      if (reDirectTo) {
        navigate(reDirectTo);
      }
      snackBarAlertContext.set({
        status: true,
        type: "error",
        message: error.message,
      });
    }
  };

  useEffect(() => {
    if (apiCall === true) {
      fetchData();
    }
  }, [endPoint, payload.search, payload.skip, payload.take]);

  return { ...response, fetchData };
};

export default useQuery;
